module.exports = __webpack_public_path__ + "static/media/logo.cc19a059.svg";